import { createRoutine } from 'redux-saga-routines';

export const fetchDownloadRequests = createRoutine('FETCH_DOWNLOAD_REQUESTS');

export const fetchDownloadRequest = createRoutine('FETCH_DOWNLOAD_REQUEST');

export const createDownloadRequest = createRoutine('CREATE_DOWNLOAD_REQUEST');

export const fetchDownloadRequestResult = createRoutine(
  'FETCH_DOWNLOAD_REQUEST_RESULT'
);

export const fetchDownloadRequestsSearchOptions = createRoutine(
  'FETCH_DOWNLOAD_REQUEST_SEARCH_OPTIONS'
);

export const deleteDownloadRequest = createRoutine('DELETE_DOWNLOAD_REQUEST');
